import api from './api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Orders API functions
export const orderApi = {
  // Lấy danh sách đơn hàng
  getOrders: async (token, params = {}) => {
    try {
      const url = `/orders`;
      const response = await api.get(url, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting orders:', error);
      throw error;
    }
  },

  // Lấy danh sách đơn hàng với tham số startDate và endDate
  getOrdersWithDateRange: async (token, apiUrl) => {
    try {
      const response = await api.get(apiUrl, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting orders with date range:', error);
      throw error;
    }
  },

  // Lấy thống kê đơn hàng
  getStatistics: async (token) => {
    try {
      const response = await api.get('/orders/statistics', {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting statistics:', error);
      throw error;
    }
  },

  // Lấy chi tiết đơn hàng
  getOrderDetail: async (token, orderId) => {
    try {
      const response = await api.get(`/orders/${orderId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting order detail:', error);
      throw error;
    }
  },

  // Cập nhật trạng thái đơn hàng
  updateOrderStatus: async (token, orderId, status) => {
    try {
      const response = await api.put(`/orders/${orderId}/status`, {
        status: status
      }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  },

  // Xóa đơn hàng
  deleteOrder: async (token, orderId) => {
    try {
      const response = await api.delete(`/orders/${orderId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting order:', error);
      throw error;
    }
  }
};

export default orderApi; 
